module.exports = __webpack_public_path__ + "img/img_customers_05.e7336c31.png";